namespace GeniuzPOS.Member {
    export interface MbTumbolLookupRow {
        MbProvince?: string;
        MbAmphur?: string;
        MbTumbol?: string;
    }

    export namespace MbTumbolLookupRow {
        export const idProperty = 'MbTumbol';
        export const nameProperty = 'MbTumbol';
        export const localTextPrefix = 'Member.MbTumbolLookup';
        export const lookupKey = 'Member.MbTumbolLookup';

        export function getLookup(): Q.Lookup<MbTumbolLookupRow> {
            return Q.getLookup<MbTumbolLookupRow>('Member.MbTumbolLookup');
        }
        export const deletePermission = null;
        export const insertPermission = null;
        export const readPermission = '';
        export const updatePermission = null;

        export declare const enum Fields {
            MbProvince = "MbProvince",
            MbAmphur = "MbAmphur",
            MbTumbol = "MbTumbol"
        }
    }
}
